"use client";

import Image from "next/image";
import Link from "next/link";
import { Check, Heart, MapPin, ShieldCheck } from "lucide-react";
import type { Dog } from "@/features/marketplace/api";
import { useAppStore } from "@/store/useAppStore";
import { useAuthGate } from "@/components/AuthGate";

export function DogCard({ dog }: { dog: Dog }) {
  const favorites = useAppStore((s) => s.favorites);
  const toggleFavorite = useAppStore((s) => s.toggleFavorite);
  const liked = favorites.includes(dog.id);
  const requireAuth = useAuthGate();
  return (
    <article className="dog-card">
      <div className="dog-image"><Link href={`/dogs/${dog.id}`} aria-label={`${dog.name} 상세 보기`}><Image src={dog.image} alt={`${dog.breed} ${dog.name}`} fill sizes="(max-width: 800px) 100vw, 33vw"/></Link><button aria-label={liked ? "찜 해제" : "찜하기"} className={`heart ${liked ? "active" : ""}`} onClick={() => void requireAuth(`/dogs/${dog.id}`, () => toggleFavorite(dog.id), "찜한 친구를 저장하려면 로그인이 필요합니다.")}><Heart fill={liked ? "currentColor" : "none"}/></button><span className={`verified ${dog.reservationStatus === "RESERVED" ? "reserved" : ""}`}>{dog.reservationStatus === "RESERVED" ? "예약 중" : <><ShieldCheck size={14}/> 검토 완료</>}</span></div>
      <div className="dog-info"><div className="dog-title"><div><small>{dog.breed}</small><h3><Link href={`/dogs/${dog.id}`}>{dog.name}</Link></h3></div><strong>{dog.price}</strong></div><p><MapPin size={15}/>{dog.location} · {dog.sex} · {dog.age}</p><div className="tags">{dog.tags.map((tag) => <span key={tag}>{tag}</span>)}</div><div className="breeder"><span>{dog.breeder.slice(0, 1)}</span><div><small>BREEDER</small><b>{dog.breeder}</b></div><Check size={13}/></div></div>
    </article>
  );
}
